let resumeData = {
  "imagebaseurl": "",
  "name": "Sandesh Deshmukh",
  "role": "Full Stack Developer",
  "linkedinId": "https://www.linkedin.com/in/sandesh-deshmukh-b817b9148/",
  "skypeid": "Your skypeid",
  "roleDescription": "I like dabbling in various parts of full stack development and like to learn about new technologies, having some cybersecurity knowledge  or simply watch web series in my free time.",
  "socialLinks": [
    {
      "name": "linkedin",
      "url": "https://www.linkedin.com/in/sandesh-deshmukh-b817b9148/",
      "className": "fa fa-linkedin"
    },
    {
      "name": "github",
      "url": "https://github.com/sandeshdeshmukh1",
      "className": "fa fa-github"
    },
    {
      "name": "twitter",
      "url": "",
      "className": "fa fa-twitter"
    }
  ],
  "aboutme": "I am currently a final year student at The MIT Academy Of Engineering and pursuing my B.Tech from here. I am a self taught Full Stack Web Developer, currently diving deeper into cybersecurity and blockchain. I believe that to be successful in life, one needs to be obsessive with their dreams and keep working towards them.",
  "address": "India",
  "website": "",
  "education": [
    {
      "UniversityName": "MIT Academy of Engineering ,Pune",
      "specialization": "Information Technology",
      "MonthOfPassing": "May",
      "YearOfPassing": "2021",
    },

  ],
  "work": [
    {
      "CompanyName": "Olcademy",
      "specialization": "Web Development Intern",
      "MonthOfLeaving": "April",
      "YearOfLeaving": "2020",
      "Achievements": "got letter of apericiation from team head "
    },
    {
      "CompanyName": "Jacklean Venture",
      "specialization": "Web Development",
      "MonthOfLeaving": "July",
      "YearOfLeaving": "2019",

    }
  ],
  "skillsDescription": "My Skills ",
  "skills": [
    {
      "skillname": "ReactJs"
    },
    {
      "skillname": "JS"
    },
    {
      "skillname": "Django"
    }
  ],
  "portfolio": [
    {
      "name": "project1",
      "description": "mobileapp",
      "imgurl": "images/portfolio/phone.jpg"
    },
    {
      "name": "project2",
      "description": "mobileapp",
      "imgurl": "images/portfolio/project.jpg"
    },
    {
      "name": "project3",
      "description": "mobileapp",
      "imgurl": "images/portfolio/project2.png"
    },
    {
      "name": "project4",
      "description": "mobileapp",
      "imgurl": "images/portfolio/phone.jpg"
    }
  ],
  "testimonials": [
    {
      "description": "I rarely come across real talents who stand out like Sandesh. I had the pleasure of working with Sandesh collaborating on team project. Sandesh's ability to handle project was unlike any I’ve seen before. Sandesh is quite well versed in his field one can fully depend on him . As a team member or a leader, Sandesh earns my highest recommendation",
      "name": "Abhik Paul Web Development at Olcademy"
    },
    {
      "description": "Very dedicated guy! Highly professional and super skilled in his work paradigm. Extremely supportive and rational person!",
      "name": "Hrithik Auchar"
    }
  ]
}

export default resumeData